import { Stack } from '@lyearn/ui';
import { SearchBar } from '@/components/SearchBar';

export const KnowledgeBaseSearch = ({
  search,
  setSearch,
}: {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <Stack>
      <SearchBar
        className="!mx-0"
        shape="square"
        size="medium"
        value={search}
        onChange={(value) => setSearch(value)}
      />
    </Stack>
  );
};
